import React, { memo } from 'react';
import { TimePicker as Picker, TimePickerProps } from '@mui/x-date-pickers/TimePicker';
import { AppPickerField } from 'components/app-picker-field';
import { useTranslate } from 'hooks/use-translate';

/**
 * Phase D1: @material-ui/pickers 3 TimePicker -> @mui/x-date-pickers. No
 * consumer in the tree today; the event-shaped `onChange` contract is kept.
 * Phase D2: the field is the app's AppPickerField (x-date-pickers 9 dropped
 * the <input> field DOM).
 */
interface Props extends Omit<TimePickerProps, 'onChange' | 'format'> {
  error?: any | { message: string };
  format?: string;
  ampm?: boolean;
  onChange: (e: { target: { value: Date | null } }) => void;
}

export const TimePicker = memo<Props>(({ error, format = 'hh:mma', onChange, ...props }) => {
  const { t } = useTranslate();
  return (
    <div className="date-field-wrapper">
      <Picker
        {...props}
        localeText={{ todayButtonLabel: t('today'), okButtonLabel: t('ok'), cancelButtonLabel: t('cancel') }}
        format={format}
        onChange={(date) => {
          onChange({ target: { value: date } });
        }}
        slots={{ field: AppPickerField }}
        slotProps={{
          openPickerButton: { edge: false },
          textField: {
            error: Boolean(error),
            helperText: error ? error.message || '' : '',
            fullWidth: true,
          },
        }}
      />
    </div>
  );
});

export default TimePicker;
